module.exports = __webpack_public_path__ + "mentos-logo-fr.png?6caf8cf5710a755df7171cada3c6e57a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentos-logo-fr.png
// module id = 139
// module chunks = 0